import React from 'react';
import { Grid } from '@material-ui/core';
import { useSyles } from './styles';

type PropsWrapper = {
  button?: boolean;
  buttonTitle?: string | number;
  actionTitle?: () => void;
  children: any;
};
const WrapperLoan = ({ children }: PropsWrapper) => {
  const classes = useSyles();
  return (
    <Grid className={classes.container} container>
      <Grid className={classes.wrapper} item>
        {children}
      </Grid>
    </Grid>
  );
};
export default WrapperLoan;
